import { DeviceRow } from 'components/tables/data/device/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the room.
 */
export default function RoomColumn({ data: { room } }: { data: DeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {room}
    </P2Regular>
  );
}
